export default __webpack_public_path__ + "static/media/PropostasConfirmadas.f1c1b35f.svg";